import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useAddArtistAccount, useUpdateArtistAccountMeta } from "@/api/mutations";
import { useGetMyAccounts } from "@/api/queries";
import { apiCall } from "@/api/shared";
import AuthPrimaryButton from "@/components/AuthPrimaryButton";
import FormError from "@/components/FormError";
import P from "@/components/P";
import Spacer from "@/components/Spacer";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

function OnboardingWelcome() {
  const { t } = useTranslation("onboarding");
  const navigate = useNavigate();
  // const accountData = AppState.useState(s => s.addAccount);
  const accountData = useAppStore(state => state.addAccount);
  const [mutationErrorMessage, setMutationErrorMessage] = useState("");
  const [validationErrorMessage, setValidationErrorMessage] = useState("");
  const [pending, setPending] = useState(false);
  const myAccounts = useGetMyAccounts();
  const addMutation = useAddArtistAccount();
  const accountMetaMutation = useUpdateArtistAccountMeta();

  const updateAccountMeta = async (aac) => {
    // update account meta
    const data = {
      account_id: aac,
      facebook_obj: accountData?.facebook,
      spotify_obj: accountData?.spotify,
      songkick_obj: accountData?.songkick,
      twitter_obj: accountData?.twitter,
      bandsintown_obj: accountData?.bandsintown,
      instagram_obj: accountData?.instagram,
    };

    accountMetaMutation.reset();

    accountMetaMutation.mutate(data, {
      onSuccess: async (response) => {
        if (response.failedvalidation) {
          setValidationErrorMessage(response.data.messages);
          setPending(false);
        }
        else {
          await myAccounts.refetch();
          const kyc = await apiCall({
            endpoint: "/rightsapp/get",
            path: "/api/v1/user/getkyc",
          });
          setPending(false);
          // AppState.update((s) => {
          //   s.addAccount = {
          //     name: null,
          //     live: null,
          //     streaming: null,
          //     spotify: null,
          //     twitter: null,
          //     facebook: null,
          //     songkick: null,
          //     bandsintown: null,
          //     instagram: null,
          //   };
          //   s.kyc = kyc;
          // });
          useAppStore.setState({
            addAccount: {
              name: null,
              live: null,
              streaming: null,
              spotify: null,
              twitter: null,
              facebook: null,
              songkick: null,
              bandsintown: null,
              instagram: null,
            },
            kyc,
          });

          if (kyc?.messages && kyc.messages.length > 0 && kyc.messages[0] === "KYC Required") {
            navigate({ to: "/security" });
          }
          else {
            navigate({ to: "/" });
          }
        }
      },
      onError: (error) => {
        setMutationErrorMessage(error.message);
        setPending(false);
      },
    });
  };

  const addAccount = async () => {
    setPending(true);
    setMutationErrorMessage("");
    setValidationErrorMessage("");

    // add artist account to rights app
    const data = {
      cataloguecode: "",
      accountname: accountData.accountName,
      facebookpageurl: accountData.facebook,
      spotifyid: accountData.spotify
        ? JSON.parse(accountData.spotify).id
        : null,
      releasedtoserviceorstore: accountData.streaming === true || accountData.streaming === "true",
      performedlastsixmonths: accountData.live === true || accountData.live === "true",
      twitterprofileurl: accountData.twitter
        ? `https://twitter.com/${accountData.twitter}`
        : null,
      soundcloudpageurl: null,
    };

    addMutation.reset();

    addMutation.mutate(data, {
      onSuccess: (result, response) => {
        if (response.failedvalidation) {
          setValidationErrorMessage(response.data.messages);
          setPending(false);
        }
        else {
          const aac = result?.model?.artistaccountcode;
          updateAccountMeta(aac);
        }
      },
      onError: (error) => {
        setMutationErrorMessage(error.message);
        setPending(false);
      },
    });
  };
  return (
    <div className="container mx-auto">
      <div className="flex flex-col items-center justify-center text-center text-white my-44">
        <Spacer />
        <P>{t("onboarding:completed-account-setup")}</P>
        <Spacer />
        <AuthPrimaryButton
          onClick={() => {
            if (pending)
              return; // Prevent multiple clicks
            setPending(true);
            addAccount();
          }}
          pending={pending}
          disabled={pending}
          arrow
          className="w-64"
        >
          {t("onboarding:go-to-dashboard")}
        </AuthPrimaryButton>

        <FormError mutationError={mutationErrorMessage} validationError={validationErrorMessage} />
      </div>
    </div>
  );
}

export default OnboardingWelcome;
